import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { HCPService } from '../hcp.service';
import { DisplayModes } from '../../../models/enums';
import { AlertService, DialogType, MessageSeverity } from '../../../services/alert.service';
import { AppTranslationService } from '../../../services/app-translation.service';
import { SaveHcpBrandClassComponent } from '../save-hcp-brand-class/save-hcp-brand-class.component';

@Component({
  selector: 'crm-hcp-brand-class',
  templateUrl: './hcp-brand-class.component.html',
  styleUrls: ['./hcp-brand-class.component.css']
})
export class HcpBrandClassComponent implements OnInit {
  @Output() closeEvent = new EventEmitter<boolean>();
  @Input() hcpId: number;
  displayMode: DisplayModes = DisplayModes.Success;
  hcpBrandClasses: any[] = [];
  showHistory = false;
  formMode = false;
  changed = false;

  @ViewChild("saveHcpClass")
  saveHcpClass: SaveHcpBrandClassComponent;


  constructor(private hcpService: HCPService, private readonly alertService: AlertService,
    private readonly translateService: AppTranslationService,) { }

  ngOnInit() {
    this.getHcpBrandClasses();
  }

  ngAfterViewInit() {
    this.saveHcpClass.changesSavedCallback = () => {
      this.formMode = false;
      this.changed = true;
      this.getHcpBrandClasses();
    };
    this.saveHcpClass.changesCancelledCallback = () => {
      this.formMode = false;
    }

    this.saveHcpClass.changesFailedCallback = () => {
      this.formMode = false;
    }

  }

  showSaveModal() {
    this.saveHcpClass.createNew(this.hcpId);
    this.formMode = true;
  }

  edit(item: any) {
    this.saveHcpClass.edit(item);
    this.formMode = true;
  }

  back() {
    this.closeEvent.emit(this.changed);
  }

  confirmDelete(item: any) {
    this.alertService.showDialog(this.translateService.getTranslation("app.deleteMsgConfirmation"), DialogType.Confirm,
      () => this.delete(item));
  }

  delete(item: any) {
    this.displayMode = DisplayModes.Loading;
    this.hcpService.deleteCPBrandHCPClass(item.id).subscribe(response => {
      this.alertService.showMessage("", this.translateService.getTranslation("DeletedSuccessfully"), MessageSeverity.Success);
      this.changed = true;
      this.getHcpBrandClasses();
    }, error => {

      this.displayMode = DisplayModes.Error;
      this.alertService.showMessage("", this.translateService.getTranslation("FailedToDelete"), MessageSeverity.Error);

    });
  }

  getHcpBrandClasses() {
    this.displayMode = DisplayModes.Loading;
    this.hcpService.getHCPBrandHCPClasses(this.hcpId, this.showHistory).subscribe(response => {
      this.hcpBrandClasses = response as any[];
      this.displayMode = DisplayModes.Success;
    }, error => {
      this.displayMode = DisplayModes.Error;
      console.log(error);
    });
  }

}
